import { initFederation } from '@angular-architects/native-federation';
import { shellFederationRemotes } from './federation/shell-federation-remotes';

initFederation(shellFederationRemotes)
  .catch(err => console.error(err))
  .then(_ => import('./bootstrap'))
  .catch(err => console.error(err));
